import { gql } from 'graphql-request'

export const QueryBlockHeroHomeTwo = gql`
  fragment FragmentBlockHeroHomeTwo on BlockHeroHomeTwoModelRecord {
          __typename
          id
          title
          preface
          description {
            value
          }
          gradient
          background
          featureCardBlocks {
            ...FragmentFeatureCardBlock
          }
        }
`
export const BlockHeroHomeTwo = {
  __typename: 'BlockHeroHomeTwo',
  fragmentName: 'FragmentBlockHeroHomeTwo',
  fragmentQuery: QueryBlockHeroHomeTwo,
  fragments: ['FragmentNavigationItem', 'FragmentFeatureCardBlock']
}
